import { StyledLink } from 'components/base/common-styles';
import { StyledCell } from '../../Table.style';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';

const NameCell = ({ name, url, widgetName, element }) => {
  const onNameClick = () => {
    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.METRICS_INSPECTION,
      click_type: TRACKING.CLICK.GOING_TO_GIT_PROVIDER,
      widget_name: widgetName,
      element
    });
    window.open(url, '_blank');
  };
  return (
    <StyledCell onClick={onNameClick} data-testid='name-cell-data-testid'>
      <StyledLink>{name}</StyledLink>
    </StyledCell>
  );
};

export default NameCell;
